<div class="title">
    <mat-card-title>Index Zoning Code {{data.Name}}</mat-card-title>
</div>

<form [formGroup]="indexationTaskSettingsForm">
    <app-data-source-category-subform
        (formReady)="formInitialized('dataSourceCategories', $event)"></app-data-source-category-subform>

    <div class="checkbox">
        <mat-checkbox formControlName="saveRawIds">Save raw Property Record Ids for debug</mat-checkbox>
    </div>

    <div class="dialog-footer">
        <mat-dialog-actions>
            <button class="action-button" mat-raised-button color="primary" (click)="onSubmit()">Index</button>
            <button class="action-button" mat-raised-button color="secondary" (click)="cancel()">Cancel</button>
        </mat-dialog-actions>
    </div>
</form>